import { SVGProps } from "react";

const BurgerMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={22}
    viewBox="0 0 32 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={17} height={2} rx={1} fill="#007AF5" />
    <rect y={20} width={25} height={2} rx={1} fill="#D9D9D9" />
    <rect y={10} width={32} height={2} rx={1} fill="#007AF5" />
  </svg>
);
export default BurgerMenu;
